/**
 *
 * Custom function
 *
 */ 

(function($) {

	function scrollAnimations() {
		
		var header = $('#js-header'),
			menu = $('#js-fixed-menu'),
			slider = $('.header-slideshow'),
			headerH = $('body').is('.is-mobile') ? header.outerHeight() : slider.outerHeight(), // Height compreso di margini e bordi
			menuH = menu.innerHeight(), // Height senza margini e bordi
			scrollValue = headerH - menuH,
			booking = $('#booking-adv'),
			posBooking = booking.position(),
			body_padding_top = 0;

		if( slider.length < 1 || slider.outerHeight() < 1 ) {
			body_padding_top = header.outerHeight();
		}

		$(window).scroll(function() {
			scrolltop = $(window).scrollTop();

			if ( scrolltop >= scrollValue) {
				if ( $('body').is('.is-mobile') ) {
					menu.addClass("scroll");
				} else {
					header.addClass("scroll");
					$('body').css({ paddingTop: body_padding_top });
				}
			} else {
				if ( $('body').is('.is-mobile') ) {
					menu.removeClass("scroll");
				} else {
					header.removeClass("scroll");
					$('body').css({ paddingTop: 0 });
				}
			}

			if ( !$('body').is('.is-mobile') && booking.length ) {
				if ( scrolltop >= posBooking.top ) {
					booking.addClass("to-bottom");
				} else {
					if ( !$('body').hasClass("no-slideshow") ) {
						booking.removeClass("to-bottom");
					}
				}
				
				if ( scrolltop + $(window).height() == $(document).height() ) {
					booking.addClass("no-display");
				} else {
					booking.removeClass("no-display");
				}
			}
		});

	}

	/*
	 * Funzione per utilizzare MixItUp da select
	 */

	function filterElements() {
		
		var filterSelect = '.select-offers',
			container = '.mix-filter-support';

		if ( $(container).length ) {
			var mixer = mixitup(container);

			$(filterSelect).on('change', function(){
				mixer.filter(this.value);
			});
		}

	}

    $(document).ready(function() {

		if ( $('body').is('.is-mobile') ) {
			filterElements();
		}

		/*
		* Nascondiamo i filtri che non avrebbero offerte
		*/
		var selectFilter = $('select.select-offers');

		if( selectFilter.length > 0 ) {
			$('option', selectFilter).each( function(){
				var thisFilter = $(this).val();

				if( typeof(thisFilter) == "string" && thisFilter != "" && thisFilter != "all" ) {
					var itemFilter = $(thisFilter);
					if( itemFilter.length < 1 )
						$(this).fadeOut();
				}
			});
		} else {
			$('.item-filter [data-filter]').each( function(){
				var thisFilter = $(this).data('filter');

				if( typeof(thisFilter) == "string" && thisFilter != "" && thisFilter != "all" ) {
					var itemFilter = $(thisFilter);
					if( itemFilter.length < 1 )
						$(this).fadeOut();
				}
			});
		}
    });


    $(window).load(function() {
		scrollAnimations();
    });

    $(window).resize(function() {


    });

})(jQuery);
